import React from 'react';
import { StepProps } from '../MultiStepModal';

export default function CertificateRequestReviewStep({ data }: StepProps) {
  const template = (data as any)?.selectedTemplate;
  const lockedKind = String((data as any)?.certificateKind || '').trim();
  const templateLabel =
    lockedKind === 'CP17_BREAKDOWN'
      ? String((data as any)?.certificateTypeLabel || 'CP17 — Breakdown')
      : String(template?.templateLabel || template?.certificateTypeName || template?.certificatePrefix || '—');

  const customerLabel = data.isNewCustomer
    ? String(data.customerName || '—')
    : String(data.customerName || '—');

  const engineerLabel = String((data as any).engineerName || (data as any).engineerId || '—');
  const scheduled = data.scheduledDate && data.scheduledTime ? `${data.scheduledDate} ${data.scheduledTime}` : '—';
  const instructions = String((data as any).instructions || '').trim();
  const jobNumber = String((data as any).jobNumber || '').trim();
  const siteName = String((data as any).siteName || '').trim();
  const siteAddress = String((data as any).siteAddress || '').trim();
  const sitePostcode = String((data as any).sitePostcode || '').trim();

  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">Review request</h3>
        <p className="step-form-subtitle">Confirm the details before requesting an engineer.</p>
      </div>

      <div className="step-form-content">
        <div className="rounded-xl border border-[#E6E6E4] bg-white p-4">
          <div className="text-sm font-semibold text-[#181818]">Request details</div>
          <div className="mt-3 grid grid-cols-1 gap-3 text-sm md:grid-cols-2">
            <div>
              <div className="text-xs text-[#686E6C]">Certificate type</div>
              <div className="mt-1 font-medium text-[#181818]">{templateLabel}</div>
            </div>
            <div>
              <div className="text-xs text-[#686E6C]">Customer</div>
              <div className="mt-1 font-medium text-[#181818]">{customerLabel}</div>
            </div>
            <div>
              <div className="text-xs text-[#686E6C]">Job number</div>
              <div className="mt-1 font-medium text-[#181818]">{jobNumber || '—'}</div>
            </div>
            <div className="md:col-span-2">
              <div className="text-xs text-[#686E6C]">Site</div>
              <div className="mt-1 font-medium text-[#181818]">
                {[siteName, siteAddress, sitePostcode].filter(Boolean).join(' · ') || '—'}
              </div>
            </div>
            <div>
              <div className="text-xs text-[#686E6C]">Engineer</div>
              <div className="mt-1 font-medium text-[#181818]">{engineerLabel}</div>
            </div>
            <div>
              <div className="text-xs text-[#686E6C]">Scheduled</div>
              <div className="mt-1 font-medium text-[#181818]">{scheduled}</div>
            </div>
          </div>

          {instructions ? (
            <div className="mt-4">
              <div className="text-xs text-[#686E6C]">Instructions</div>
              <div className="mt-1 whitespace-pre-wrap rounded-lg border border-[#E6E6E4] bg-[#FAFAF9] p-3 text-sm text-[#181818]">
                {instructions}
              </div>
            </div>
          ) : null}
        </div>

        <div className="mt-4 rounded-lg border border-[#E6E6E4] bg-[#FAFAF9] p-4 text-xs text-[#686E6C]">
          Clicking “Complete” will create a scheduled job assigned to the engineer.
        </div>
      </div>
    </div>
  );
}
